import React from 'react';
import { SelectField, TextField } from 'react-admin';
import PropTypes from 'prop-types';
import EjectedDatagrid from '../../../components/ejected/Datagrid';
import EjectedSelectField from '../../../components/ejected/SelectField';
import { STATUSES_PAYMENT } from '../../../common';
import TextFieldWithPrice from '../../../components/TextFieldWithPrice';
import TextFieldWithDate from '../../../components/TextFieldWithDate';

const Datagrid = ({
  create, edit, total, companies, ...rest
}) => (
  <EjectedDatagrid
    currentSort={{ order: 'ASC' }}
    create={create}
    edit={edit}
    {...rest}
  >
    <SelectField
      label="Юр. Компания"
      source="companyId"
      choices={companies}
      customstyles={{
        width: '192px', backgroundColor: '#2c9bc3'
      }}
    />
    <TextFieldWithDate source="time" isDate label="Дата" customstyles={{ width: '62px', backgroundColor: '#2c9bc3' }} />
    <TextFieldWithPrice source="sum" label="Сумма" customstyles={{ width: '140px', backgroundColor: '#2c9bc3' }} cellstyles={{ fontWeight: 500 }} />
    <EjectedSelectField source="status" label="Платеж" choices={STATUSES_PAYMENT} customstyles={{ width: '106px', backgroundColor: '#35cd59' }} />
    <TextField source="comment" label="Комментарий" customstyles={{ width: '170px', backgroundColor: '#2c9bc3' }} />
  </EjectedDatagrid>
);

Datagrid.defaultProps = {
  edit: null,
  create: null,
  companies: []
};

Datagrid.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
  companies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }))
};

export default Datagrid;



// WEBPACK FOOTER //
// ./src/pages/callcenter/payments/Datagrid.js